import React from 'react';
import { Skeleton } from '@mui/material';
import { DomainsDetails } from '../../libs/domains-management/components';
import { Page, PageBody, PageHeader } from '../../libs/shared/page';
import { QlfPageErrorBoundary } from '../../libs/shared/QlfPageErrorBoundary';
import { SubdomainsProvider } from '../../libs/domains-management/SubdomainsContext';
import { TopBar } from '../../libs/shared/layout/TopBar';
import { useAccounts } from '../../libs/accounts/AccountsContext';

export function DomainsManagementIndexPage() {
  const { isLoading } = useAccounts();

  return (
    <SubdomainsProvider>
      <Page>
        <PageHeader>
          <TopBar />
        </PageHeader>
        <PageBody>
          <QlfPageErrorBoundary>
            {isLoading('getDomains') ? <Skeleton /> : <DomainsDetails />}
          </QlfPageErrorBoundary>
        </PageBody>
      </Page>
    </SubdomainsProvider>
  );
}
